import React from 'react';
import { PRICE } from './salesData';
interface PriceBlockProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  /** 'inline' comprime el bloque en una fila (hero mobile). */
  layout?: 'stack' | 'inline';
  tone?: 'light' | 'dark';
}

/**
 * Único bloque de precio de la landing: precio anterior tachado en topo,
 * etiqueta de oferta en frambuesa y precio vigente grande en chocolate.
 */
export function PriceBlock({
  className = '',
  size = 'md',
  layout = 'stack',
  tone = 'light'
}: PriceBlockProps) {
  const current = size === 'lg' ? 'text-[3rem] sm:text-[3.6rem]' : size === 'sm' ? 'text-[2.1rem] sm:text-[2.5rem]' : 'text-[2.6rem] sm:text-[3.1rem]';
  const previousColor = tone === 'dark' ? 'text-white/50' : 'text-taupe';
  const currentColor = tone === 'dark' ? 'text-white' : 'text-charcoal';
  const noteColor = tone === 'dark' ? 'text-white/60' : 'text-taupe';
  if (layout === 'inline') {
    return <div className={`flex flex-col items-center ${className}`} data-id="element-206" data-mp="werwoz8sdkxt">
        <div className="flex items-center justify-center gap-2.5" data-id="element-207" data-mp="1ryyndhy3x9u2">
          <p className={`font-sans text-[0.95rem] font-medium tabular-nums ${previousColor}`} style={{
          textDecoration: 'line-through'
        }} data-id="element-208" data-mp="1wyb6brluxwrd">
            {PRICE.previous}
          </p>
          <p className={`font-display font-extrabold leading-none tracking-tight tabular-nums ${current} ${currentColor}`} data-id="element-209" data-mp="26nmdh8p6orcm">
            {PRICE.current}
          </p>
        </div>
        <p className={`mt-1.5 font-sans text-[0.68rem] font-semibold uppercase tracking-[0.1em] ${noteColor}`} data-id="element-210" data-mp="1e11lq74sqd8j">
          {PRICE.note}
        </p>
      </div>;
  }
  return <div className={`flex flex-col items-center ${className}`} data-id="element-211" data-mp="1n1q1b69u8lnj">
      <div className="flex items-center gap-2.5" data-id="element-212" data-mp="2ue8j6tbptzjg">
        <p className={`font-sans text-sm font-medium tabular-nums sm:text-base ${previousColor}`} style={{
        textDecoration: 'line-through'
      }} data-id="element-213" data-mp="2udp37i5mll82">
          {PRICE.previous}
        </p>
        <span className="rounded-full bg-gold px-2.5 py-0.5 font-display text-[0.62rem] font-bold uppercase tracking-[0.1em] text-charcoal" data-id="element-214" data-mp="z98xgi0fo2mr">
          Oferta
        </span>
      </div>
      <p className={`mt-1 font-display font-extrabold leading-[0.95] tracking-tight tabular-nums ${current} ${currentColor}`} data-id="element-215" data-mp="18agxb4illbiy">
        {PRICE.current}
      </p>
      <p className={`mt-2 font-sans text-[0.7rem] font-semibold uppercase tracking-[0.12em] ${noteColor}`} data-id="element-216" data-mp="fmbamc7zhcgh">
        {PRICE.note}
      </p>
    </div>;
}